import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { CatCategoryPromoterModel } from 'src/app/model/cat-category-promoter.model';
import { CatCategoryPromoterService } from 'src/app/services/cat-category-promoter.service';

@Component({
  selector: 'app-modal-category-promoter',
  templateUrl: './modal-category-promoter.component.html',
  styleUrls: ['./modal-category-promoter.component.css']
})
export class ModalCategoryPromoterComponent implements OnInit {
  @Input() category:CatCategoryPromoterModel;
  @Input() page:string;
  @Input() mode:string;

  // estado pagina
  public viewStatus=1;

  // mascaras
  public customPatterns={
    'A':{pattern:new RegExp('[a-zA-Z0-9ñÑ ]')},                     // inputs regulares
    'C':{pattern:new RegExp('[a-zA-Z0-9áéíóúÁÉÍÓÚüÜñÑ,._:%\/() \-]')},       // comentarios (acepta acentos, comas y puntos)
    'N':{pattern:new RegExp('[0-9]')} 
  };

  ////////////////
  constructor(
    private categoryPromoterService:CatCategoryPromoterService,
    private modalService: NgbModal,
    private toastr:ToastrService
  ) { }
  ngOnInit() { }

  //
  toggleActive=()=> this.category.activeId=this.category.activeId===1?0:1;
  isValid=()=> {
    let valid=true;
    let errors=[];
    if(this.descriptionError()) errors.push('Necesita capturar una descripción.');
    if(errors.length>0) {
      valid=false;
      this.toastr.error(errors.join('<br>'), '¡Atención!', {enableHtml:true});
    }
    return valid;
  }
  save=()=> {
    if(this.isValid()) {
      // mostrar spinner
      this.viewStatus=0;
      // enviar informacion
      this.category.description=this.category.description.toUpperCase();
      this.categoryPromoterService.save(this.category)
        .pipe(
          tap((resp:any)=> {
            console.log(resp);
            this.modalService.dismissAll('success');
            this.toastr.success('La categoría se guardó con éxito.');
          }),
          catchError(error=> {
            console.log(error);
            this.modalService.dismissAll('failure');
            return of(this.toastr.error('Ocurrió un error al intentar guardar la categoría.'));
          })
        )
        .subscribe();
    }
  }
  close=()=> this.modalService.dismissAll();

  // HELPERS
  descriptionError=()=> !this.category.description || this.category.description.trim()==='';
}